<template>
  <b-modal v-model="visible" title="Click en el archivo que desee descargar">
    <b-list-group>
      <b-list-group-item
        target="_blank"
        class="cursor-pointer"
        v-for="(archivo, index) in archivos"
        :key="index"
        @click="descargarArchivo(archivo)"
      >{{mapearNombre(archivo)}}</b-list-group-item>
    </b-list-group>
    <template v-slot:modal-footer>
      <div class="w-100">
        <b-button variant="primary" class="float-right" @click="visible = false">Cerrar</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ['tomador', 'nroPoliza', 'nroEndoso'],
  data() {
    return {
      visible: false,
      archivos: []
    };
  },

  computed: {
    codAgente() {
      return this.$store.state.auth.cod_agente
    }
  },
  methods: {
    toggle() {
      this.visible = !this.visible;
    },
    mapearNombre(archivo){
        if(archivo.includes('TOASEG.pdf')) return 'ARCHIVO ASEGURADO';
        else if (archivo.includes('TOASEG_CERT.pdf')) return 'ARCHIVO CERTIFICADO ORIGINAL';
             else if (archivo.includes('TOORG.pdf')) return 'ARCHIVO ORGANIZADOR';
                  else if (archivo.includes('TOPROD.pdf')) return 'ARCHIVO PRODUCTOR';
                       else return this.tipoArchivo(archivo);
    },
    tipoArchivo(archivo) {
      const arr = archivo.split('/');

      return arr[arr.length - 1];
    },
    async descargarArchivo(archivo) {
      //console.log(archivo);
      let loader = this.$loading.show();
      this.visible = false;
      await this.$api({
        url: `files/${archivo}`,
        method: 'GET',
        responseType: 'blob',
      }).then(res => {
        const fileURL = URL.createObjectURL(res.data);
        //window.open(fileURL);
        var a = document.createElement("a")
        document.body.appendChild(a)
        a.style="display: none"        
        a.href = fileURL
        a.download = this.tipoArchivo(archivo);
        a.click();
        window.URL.revokeObjectURL(fileURL);
        document.body.removeChild(a);
      }).catch(err => {
        const toast = this.$toast;
        const fr = new FileReader();
        fr.onload = function() {
          toast.error('No se puede descargar el archivo. ' + fr.result.replace(/"/g, ''));
        };
        fr.readAsText(err.response.data);
      });

      loader.hide();
      this.visible = true;
    }
  }
};
</script>
